// src/components/common/ProgressBar.jsx
import React from "react";

/**
 * ProgressBar: percent(0-100)
 */
export default function ProgressBar({ percent = 0, height = 8 }) {
  return (
    <div className="bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
      <div
        style={{
          width: `${Math.max(0, Math.min(100, percent))}%`,
          height,
          background: "linear-gradient(90deg,#34d399,#059669)",
          transition: "width 300ms ease",
        }}
      />
    </div>
  );
}
